import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyCUo2Rhd4iL1bJLCkWV2m21lO4iFNVZtVs",
  authDomain: "carebeacon-billing.firebaseapp.com",
  projectId: "carebeacon-billing",
  storageBucket: "carebeacon-billing.firebasestorage.app",
  messagingSenderId: "454150839562",
  appId: "1:454150839562:web:6c4f966cfab2259de92ef3"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export default app;
